<template>
  <div>
    <oil-cap
        title="ГТД"
        :buttons="[{name:'создать ГТД',route:'gdt'}]"
    />
    <v-divider class="my-2"/>

    <oil-table
        :keys="keys"
        :items="gdts"
        :paginate='count'
        @paginateAction='paginate'
        :rowClick="rowClick"
    >
      <template v-slot:Status="{value}">
        <v-chip color="success" v-text="value"/>
      </template>
      <template v-slot:Id="{value}">
        <v-btn icon>
          <v-icon color="primary" v-text="'mdi-pen'"/>
        </v-btn>
      </template>
    </oil-table>
  </div>
</template>

<script>
import {coreApi} from "~/services/core";

export default {
  components: {
    OilCap: () => import('@/components/helper/oil.cap'),
    OilTable: () => import('@/components/helper/oil.table'),
  },
  data: () => ({
    keys: [
      {
        text: 'Импортер',
        value: 'Importer'
      },
      {
        text: 'Номер',
        value: 'Number'
      },
      {
        text: 'Товар',
        value: 'ProductName'
      },
      {
        text: 'Количество',
        value: 'TotalQuantityInTons'
      }
    ],
    gdts: [],
    count:{
      count:0
    }
  }),
  async created() {
    await this.paginate((this.currentPage-1)*10)
    // this.gdts = gdts.data?.map(gdt => {
    //   return {
    //     Id: gdt?.Id,
    //     Importer: gdt?.Importer?.Name,
    //     Number: gdt?.Number,
    //     ProductName: gdt?.Product?.Name,
    //     TotalQuantityInTons: gdt?.TotalQuantityInTons,
    //   }
    // }) || []

  },
  methods: {
    rowClick({Id}) {
      this.$router.push({
        name: 'gdt',
        params: {id: Id}
      })
    },
    async paginate(page) {
      const gdts = await coreApi.get(`gtd/${page}`)
      const { count, dates } = gdts.data
      this.count.count = count
      this.gdts = dates?.map(gdt => {
        return {
          Id: gdt?.Id,
          Importer: gdt?.Importer?.Name,
          Number: gdt?.Number,
          ProductName: gdt?.Product?.Name,
          TotalQuantityInTons: this.regular(parseFloat(gdt?.TotalQuantityInTons).toFixed(4)),
        }
      })
    },
  }
}
</script>